import { template as template_eef1b87b81bd49d280147e6018194f1a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import ResetScroll from 'client-portal/modifiers/reset-scroll';
import styles from './loading-clinician-search.module.scss';
import t from 'ember-intl/helpers/t';
const CARD_SLOTS = [
    0,
    1
];
export default class RequestStepsLoadingLoadingClinicianSearch extends Component {
    styles = styles;
    cardSlots = CARD_SLOTS;
    static{
        template_eef1b87b81bd49d280147e6018194f1a(`
    <div class={{styles.component}} {{ResetScroll}} data-test-clinician-search-loading>
      <div class="loading-clinician-search-chrome" aria-hidden="true">
        {{#unless @hideBarItems}}
          <div class="skeleton-filter-bar">
            <div class="skeleton-filter-pills">
              <div class="skeleton-filter-pill"></div>
              <div class="skeleton-filter-pill"></div>
              <div class="skeleton-filter-pill"></div>
              <div class="skeleton-filter-pill"></div>
            </div>
          </div>
          <div class="skeleton-filtered-summary-block">
            <div class="skeleton-summary-line skeleton-summary-line-primary"></div>
          </div>
        {{/unless}}
      </div>

      <div class="loading-items {{if @hasSignInBox 'with-sign-in-box'}}">
        {{#each this.cardSlots}}
          <div
            class="loading-item clinician-skeleton-card"
            data-test-clinician-search-skeleton-card
          >
            <div class="skeleton-avatar" aria-hidden="true"></div>
            <div class="skeleton-card-body">
              <div class="skeleton-text skeleton-name" aria-hidden="true"></div>
              <div class="skeleton-text skeleton-title" aria-hidden="true"></div>
              <div class="skeleton-text skeleton-location" aria-hidden="true"></div>
              <div class="skeleton-pills" aria-hidden="true">
                <div class="skeleton-pill"></div>
                <div class="skeleton-pill"></div>
              </div>
              <div class="skeleton-next" aria-hidden="true">
                <div class="skeleton-next-icon"></div>
                <div class="skeleton-text skeleton-next-line"></div>
              </div>
            </div>
            <div class="skeleton-button skeleton-cta" aria-hidden="true"></div>
          </div>
        {{/each}}
      </div>

      <p class="loading-text">{{t "loading.clinicians"}}</p>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
